// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Create_container__dk-cP {
  animation: Create_appear__n-HJ3 0.3s 0.3s both;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Create_container__dk-cP .Create_header__WPUlI {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Create_container__dk-cP .Create_header__WPUlI .Create_titleContainer__qBXZb {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Create_container__dk-cP .Create_header__WPUlI .Create_titleContainer__qBXZb h4 {
  width: 92%;
  text-align: center;
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Create_container__dk-cP .Create_header__WPUlI .Create_arrowback__pOBwm {
  transition: 0.3s;
}

.Create_container__dk-cP .Create_header__WPUlI .Create_arrowback__pOBwm:hover {
  transition: 0.3s;
  cursor: pointer;
  scale: 1.1;
  filter: brightness(0.8);
}

.Create_container__dk-cP .Create_formulario__ZwOkq {
  justify-content: center;
  align-items: center;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_datos__QKl8Q {
  justify-content: space-around;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_datos__QKl8Q .Create_item__3\\+rqK {
  align-items: center;
  margin-bottom: 20px;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U {
  margin-top: 10px;
  justify-content: space-around;
  align-items: flex-start;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL {
  justify-content: center;
  align-items: center;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_title__-nQfv {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_title__-nQfv p {
  font-size: 1.8rem;
  font-weight: 300;
  margin: 0;
  margin-left: 5px;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_add__vrfx9 {
  transition: 0.3s;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_add__vrfx9:hover {
  transition: 0.3s;
  border-radius: 100%;
  background-color: #22222212;
  cursor: pointer;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_items__oqe0T {
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 300;
  text-align: center;
  color: #222222cb;
}

.Create_container__dk-cP .Create_formulario__ZwOkq .Create_boxes__k633U .Create_box__6V9jL .Create_chip__pX1sz {
  animation: Create_init__nrt4h 0.3s both;
}

@keyframes Create_init__nrt4h {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Create_init2__GDYFS {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Create_appear__n-HJ3 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Refactor User/Create/Create.module.css"],"names":[],"mappings":"AAAA;EACE,8CAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: appear 0.3s 0.3s both;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  width: 92%;\n  text-align: center;\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .arrowback {\n  transition: 0.3s;\n}\n\n.container .header .arrowback:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  scale: 1.1;\n  filter: brightness(0.8);\n}\n\n.container .formulario {\n  justify-content: center;\n  align-items: center;\n}\n\n.container .formulario .datos {\n  justify-content: space-around;\n}\n\n.container .formulario .datos .item {\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .formulario .boxes {\n  margin-top: 10px;\n  justify-content: space-around;\n  align-items: flex-start;\n}\n\n.container .formulario .boxes .box {\n  justify-content: center;\n  align-items: center;\n}\n\n.container .formulario .boxes .box .title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.container .formulario .boxes .box .title p {\n  font-size: 1.8rem;\n  font-weight: 300;\n  margin: 0;\n  margin-left: 5px;\n}\n\n.container .formulario .boxes .box .add {\n  transition: 0.3s;\n}\n\n.container .formulario .boxes .box .add:hover {\n  transition: 0.3s;\n  border-radius: 100%;\n  background-color: #22222212;\n  cursor: pointer;\n}\n\n.container .formulario .boxes .box .items {\n  justify-content: center;\n  align-items: center;\n  font-size: 1.3rem;\n  font-weight: 300;\n  text-align: center;\n  color: #222222cb;\n}\n\n.container .formulario .boxes .box .chip {\n  animation: init 0.3s both;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes init2 {\n  0% {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes appear {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Create_container__dk-cP`,
	"appear": `Create_appear__n-HJ3`,
	"header": `Create_header__WPUlI`,
	"titleContainer": `Create_titleContainer__qBXZb`,
	"arrowback": `Create_arrowback__pOBwm`,
	"formulario": `Create_formulario__ZwOkq`,
	"datos": `Create_datos__QKl8Q`,
	"item": `Create_item__3+rqK`,
	"boxes": `Create_boxes__k633U`,
	"box": `Create_box__6V9jL`,
	"title": `Create_title__-nQfv`,
	"add": `Create_add__vrfx9`,
	"items": `Create_items__oqe0T`,
	"chip": `Create_chip__pX1sz`,
	"init": `Create_init__nrt4h`,
	"init2": `Create_init2__GDYFS`
};
export default ___CSS_LOADER_EXPORT___;
